import {BaseHttpError} from './BaseHttpError'
import {ErrorResponseBody} from '../../response/ErrorResponseBody'
import {HttpStatusCode} from '../../Constants'

export class HttpTimeoutError extends BaseHttpError {

    constructor(readonly responseBody: ErrorResponseBody) {
        super('HttpTimeoutError', HttpStatusCode.TIMEOUT, responseBody)
    }
}
